import { useFormState, useMoney } from './context';
import { SummaryBody } from './Summary';

export function Success() {
  const state = useFormState();
  const money = useMoney();
  const name = state.values.user.first_name.trim();
  return (
    <section className="cbf-card cbf-success" role="status" aria-live="polite">
      <h2 className="cbf-h2">You&rsquo;re booked{name ? `, ${name}` : ''}!</h2>
      <p className="cbf-p">
        We&rsquo;ve emailed a confirmation to <strong>{state.values.user.email.trim()}</strong>.
        {state.result?.id ? ` Your booking reference is #${state.result.id}.` : ''}
      </p>
      <div className="cbf-summary">
        <SummaryBody />
      </div>
      {state.estimate.data ? <p className="cbf-help">Total {money(state.estimate.data.total)} — your card is authorized now and charged after your detail.</p> : null}
    </section>
  );
}
